import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../global-variables';
import { createToolTip, prettyUserName, storagePrettyConverter } from './utils';
import { JobConstants } from './job-constants';

@Pipe({name: 'username'})
export class UserNamePipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
    transform(value): any {
        if ( value ) {
            return prettyUserName(value);
        } else {
            return '-';
        }
    }
}

@Pipe({name: 'prettyStorage'})
export class StoragePrettyRenderPipe implements PipeTransform {
    transform(value): any {
        if(value && typeof value === 'object') {
            if ( value.number && value.number > 0 ) {
                return storagePrettyConverter(value.number, (value.unit ? value.unit : 'MB'));
            } else {
                var returnString =  "0" + " " +  (value.unit ? value.unit : 'MB');
                return returnString;
            }
        }else{
            if (value && value > 0) {
                return storagePrettyConverter(value, 'MB');
            } else {
                 return "0 MB";
            }
        }
    }
}

@Pipe({name: 'prettyCpu'})
export class CpuPrettyRenderPipe implements PipeTransform {
    transform(value): any {
        if(value && typeof value === 'object') {
            if ( value.number && value.number > 0 ) {
                return storagePrettyConverter(value.number, (value.unit ? value.unit : 'MHz'));
            } else {
                var returnString =  "0" + " " +  (value.unit ? value.unit : 'MHz');
                return returnString;
            }
        }else{
            if (value && value > 0) {
                return storagePrettyConverter(value, 'MHz');
            } else {
                 return "0 MHz";
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/utils/utils-pipes.pipe.ts